export default (audioEl) => {
	const audioCtx = new (window.AudioContext || window.webkitAudioContext)();
	const source = audioCtx.createMediaElementSource(audioEl);

	const frequencyAnalyser = audioCtx.createAnalyser();

	frequencyAnalyser.fftSize = 128;

	const frequencyArray = new Uint8Array(frequencyAnalyser.frequencyBinCount);

	source.connect(frequencyAnalyser);
	source.connect(audioCtx.destination);

	return {
		source,
		frequencyAnalyser,
		frequencyArray
	};
};